module.exports = __webpack_public_path__ + "img/banner-mobile.ebb91bc0.png";